import entries from "./entries.json";

export const PRIZE_ODDS_FACTOR = 0.05;

export function buildEntryByName(list) {
    const map = {};
    for (const row of list) {
        map[row.name] = row;
    }
    return map;
}

export const entryByNameStatic = buildEntryByName(entries);

export function oddsWeightedTotalForPerson(person, entryByName) {
    let total = 0;
    for (const s of person.summary || []) {
        const mult = entryByName[s.name]?.multiplier ?? 0;
        total += PRIZE_ODDS_FACTOR * s.amount * mult;
    }
    return total;
}

export function sortRankingsByOddsScore(rankings, entryByName) {
    return [...rankings]
        .map((person) => ({
            person,
            oddsScore: oddsWeightedTotalForPerson(person, entryByName),
        }))
        .sort((a, b) => {
            if (b.oddsScore !== a.oddsScore) {
                return b.oddsScore - a.oddsScore;
            }
            return a.person.name.localeCompare(b.person.name);
        })
        .map(({ person }) => person);
}
